import { FormBuilderService } from '../../../services/form-builder.service';
import {
  IFormbuilderFieldTypeConfiguration,
  IBaseConfigurationFormModel,
  ISlotBookingConfigurationFormModel,
} from '../../../models/form-builder-types-configurations.model';
import { fieldsBaseConfigurationFormModel } from './shared.configuration';
import {
  baseFieldParseIntoSettingsFormModel,
  baseFieldUpdateFromSettingsFormModel,
  getDefaultBaseSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  getRequiredValidatorFormConfig,
  getValidationFieldsFormConfig,
} from '../form-fields-formly-validations/form-fields-formly-validation-field-generator.util';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';

export const defaultCustomSlotBookingConfigFormModel: ISlotBookingConfigurationFormModel =
  {
    ...fieldsBaseConfigurationFormModel(),
  };

export const slotbookingGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultCustomSlotBookingConfigFormModel,
      formlyForm: [
        ...getDefaultBaseSettingsConfigFormly(formBuilderServiceInstance),
        ...getSlotBookingFieldSettingsConfig(),
      ],
    },
    validations: {
      formModel: {},
      formlyForm: [
        getRequiredValidatorFormConfig(),
        getValidationFieldsFormConfig(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const slotBookingFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IBaseConfigurationFormModel => {
  const model: ISlotBookingConfigurationFormModel =
    baseFieldParseIntoSettingsFormModel(field);

  const seatsConfig = field.props?.['configs'][3];
  const invalidSlotMessage = field.validation?.messages?.['invalidSlot'];

  model.scheduleFieldContentConfig = {
    scheduleId: field.props?.['scheduleId'],
    invalidSlotMessage: invalidSlotMessage as string,
    maxSeatErrorMessage: seatsConfig['maxSeatErrorMessage'],
    minSeatErrorMessage: seatsConfig['minSeatErrorMessage'],
    numbersOnlyErrorMessage: seatsConfig['numbersOnlyErrorMessage'],
  };

  return model;
};

export const slotBookingFieldUpdateFromSettingsFormModel = (
  model: ISlotBookingConfigurationFormModel,
  slotBookingField: FormlyFieldConfig
): FormlyFieldConfig => {
  slotBookingField = baseFieldUpdateFromSettingsFormModel(
    model,
    slotBookingField
  );

  const updatedConfigs = slotBookingField.props?.['configs'].map(
    (obj: Record<string, unknown>, index: number) =>
      index === 3
        ? {
            ...obj,
            maxSeatErrorMessage:
              model.scheduleFieldContentConfig?.maxSeatErrorMessage,
            minSeatErrorMessage:
              model.scheduleFieldContentConfig?.minSeatErrorMessage,
            numbersOnlyErrorMessage:
              model.scheduleFieldContentConfig?.numbersOnlyErrorMessage,
          }
        : obj
  );

  if (slotBookingField.props) {
    slotBookingField.props['scheduleId'] =
      model.scheduleFieldContentConfig?.scheduleId;
    slotBookingField.props['configs'] = updatedConfigs;
  } else {
    slotBookingField.props = {
      scheduleId: model.scheduleFieldContentConfig?.scheduleId,
      configs: updatedConfigs,
    };
  }

  if (model.scheduleFieldContentConfig?.invalidSlotMessage) {
    const validationMessages = slotBookingField.validation?.messages;
    slotBookingField.validation = {
      messages: {
        ...validationMessages,
        invalidSlot: model.scheduleFieldContentConfig?.invalidSlotMessage,
      },
    };
  }

  return slotBookingField;
};

export const getSlotBookingFieldSettingsConfig = (): FormlyFieldConfig[] => {
  return [
    {
      key: 'scheduleFieldContentConfig',
      id: 'scheduleFieldContentConfig',
      type: EIremboFormlyFieldTypes['formly-group'],
      fieldGroupClassName: 'schedule-widget-formly-group',
      props: {
        dragDisabled: false,
      },
      fieldGroup: [
        {
          key: 'scheduleId',
          type: EIremboFormlyFieldTypes.customdropdownpaginated,
          props: {
            label: 'Schedule',
            placeholder: 'Select schedule',
            bindLabel: 'name',
            bindValue: 'id',
            virtualScroll: true,
            required: true,
            useBaseUrl: true,
            dataset: {
              url: `/service/api/v1/schedules`,
              params: {
                page: 0,
                size: 10,
                sortDirection: 'DESC',
                sort: 'created_date',
                status: 'ACTIVE',
              },
              pagination: true,
              searching: true,
              dataField: 'data.content',
              searchField: 'name',
            },
          },
        },
        {
          key: 'invalidSlotMessage',
          type: 'input',
          props: {
            label: 'Invalid slot message',
            required: true,
            placeholder: 'Provide invalid slot message',
          },
          validation: {
            messages: {
              required: 'This field is required',
            },
          },
        },
        {
          key: 'maxSeatErrorMessage',
          type: 'input',
          props: {
            label: 'Maximum seats message',
            required: true,
            placeholder: 'Provide message',
          },
          validation: {
            messages: {
              required: 'This field is required',
            },
          },
        },
        {
          key: 'minSeatErrorMessage',
          type: 'input',
          props: {
            label: 'Minimum seats message',
            required: true,
            placeholder: 'Provide message',
          },
          validation: {
            messages: {
              required: 'This field is required',
            },
          },
        },
        {
          key: 'numbersOnlyErrorMessage',
          type: 'input',
          props: {
            label: 'Numbers only message',
            required: true,
            placeholder: 'Provide message',
          },
          validation: {
            messages: {
              required: 'This field is required',
            },
          },
        },
      ],
    },
  ];
};
